import React from 'react';
import PropTypes from 'prop-types';

const TableValue = ({ value }) => <span>{value}</span>;

TableValue.propTypes = { value: PropTypes.string.isRequired };

export default TableValue;
